module.exports = __webpack_public_path__ + "static/media/arrow.c79481bc.png";